const STORAGE_PREFIX = 'photo-card-diary-covers-v1';

export const DIARY_COVER_PRESETS = [
  {
    id: 'forest',
    coverColor: '#2EF0B6',
    textColor: '#041612',
    accentColor: '#B9FFE9',
    pageColor: '#F3FFF9',
    pageEdgeColor: '#CFF7E8'
  },
  {
    id: 'wine',
    coverColor: '#FF4DB8',
    textColor: '#2A071C',
    accentColor: '#FFD2F0',
    pageColor: '#FFF2FA',
    pageEdgeColor: '#F8C8E6'
  },
  {
    id: 'navy',
    coverColor: '#2C78FF',
    textColor: '#F8FBFF',
    accentColor: '#C8DAFF',
    pageColor: '#F1F6FF',
    pageEdgeColor: '#C9D8F8'
  },
  {
    id: 'sand',
    coverColor: '#FFBE0B',
    textColor: '#2B1700',
    accentColor: '#FFE8A0',
    pageColor: '#FFF8E7',
    pageEdgeColor: '#F6D788'
  },
  {
    id: 'rose',
    coverColor: '#FF6B6B',
    textColor: '#2D0D10',
    accentColor: '#FFD2D2',
    pageColor: '#FFF3F2',
    pageEdgeColor: '#F4C6C4'
  },
  {
    id: 'charcoal',
    coverColor: '#8B5DFF',
    textColor: '#F9F7FF',
    accentColor: '#DCCFFF',
    pageColor: '#F6F0FF',
    pageEdgeColor: '#DCCBF4'
  }
];

const getStorageKey = (userId, artistId) => {
  return `${STORAGE_PREFIX}:${userId}:${artistId}`;
};

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (_error) {
    return {};
  }
};

export const loadDiaryCoverMap = ({ userId, artistId }) => {
  if (!userId || !artistId) return {};
  return safeParse(localStorage.getItem(getStorageKey(userId, artistId)) || '{}');
};

export const saveDiaryCoverMap = ({ userId, artistId, coverMap }) => {
  if (!userId || !artistId) return;
  localStorage.setItem(getStorageKey(userId, artistId), JSON.stringify(coverMap));
};

export const getDiaryCoverPreset = (presetId) => {
  return DIARY_COVER_PRESETS.find((preset) => preset.id === presetId) || DIARY_COVER_PRESETS[0];
};

const getDefaultDiaryCoverTitle = (member) => {
  return member?.name || '포카 다이어리';
};

export const getDefaultDiaryCover = ({ member, memberIndex = 0 }) => {
  return {
    colorId: DIARY_COVER_PRESETS[memberIndex % DIARY_COVER_PRESETS.length].id,
    title: getDefaultDiaryCoverTitle(member)
  };
};

export const getDiaryCover = ({ coverMap, member, memberIndex = 0 }) => {
  const defaultCover = getDefaultDiaryCover({ member, memberIndex });
  const storedCover = coverMap?.[member?.memberId] || {};
  const legacyDefaultTitles = new Set(
    [member?.name, member?.shortName, member?.name ? `${member.name} 포카` : null].filter(Boolean)
  );
  const normalizedStoredCover = legacyDefaultTitles.has(storedCover.title)
    ? {
        ...storedCover,
        title: getDefaultDiaryCoverTitle(member)
      }
    : storedCover;

  return {
    ...defaultCover,
    ...normalizedStoredCover
  };
};
